module.exports = __webpack_public_path__ + "img/no-avatar.a7ce18de.png";